// Every permission that gives access to the Admin section. Keep in sync with
// NAV_PERMISSION_KEYS in backend/core/models.py when adding an Admin page.
export const ADMIN_PERMISSION_KEYS = [
  'admin_settings', 'admin_companies', 'admin_farms',
  'admin_bunch_sleevers', 'admin_ribbons', 'admin_users',
  'admin_exporters', 'admin_brands', 'admin_transportations',
  'admin_destinations', 'admin_drivers', 'admin_box_types', 'admin_inspectors',
  'admin_fumigation_products', 'admin_fumigation_companies', 'admin_fumigation_pilots',
];

// Every permission that gives access to the Producción section.
export const PRODUCTION_PERMISSION_KEYS = ['production', 'harvest', 'recobro', 'production_summary', 'production_budget', 'fumigation'];
